import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { DZ_COLOR_PURPLE_500 } from '@blk/daisy/core/styles';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class DzProgressSpinnerComponent {
    constructor() {
        /**
         * Used to change the color of spinner.<br/>
         * Optional
         */
        this.color = DZ_COLOR_PURPLE_500;
        /**
         * Used to set the height and width in px.<br/>
         * Optional
         */
        this.size = '120';
        /**
         * Used to set the thickness of spinner in px.<br/>
         * Optional
         */
        this.borderWidth = '12';
    }
}
DzProgressSpinnerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzProgressSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DzProgressSpinnerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: DzProgressSpinnerComponent, selector: "dz-progress-spinner", inputs: { color: "color", size: "size", borderWidth: "borderWidth" }, ngImport: i0, template: "<div\n\tclass=\"spinner\"\n\t[ngStyle]=\"{\n\t\t'border-width.px': borderWidth,\n\t\t'width.px': size,\n\t\t'height.px': size,\n\t\t'border-color': color,\n\t\t'border-top-width.px': borderWidth,\n\t\t'border-top-color': 'transparent'\n\t}\"\n></div>\n", styles: [".spinner{animation:load 1s linear infinite;border-radius:50%;border-style:solid}@keyframes load{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"], directives: [{ type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzProgressSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dz-progress-spinner', template: "<div\n\tclass=\"spinner\"\n\t[ngStyle]=\"{\n\t\t'border-width.px': borderWidth,\n\t\t'width.px': size,\n\t\t'height.px': size,\n\t\t'border-color': color,\n\t\t'border-top-width.px': borderWidth,\n\t\t'border-top-color': 'transparent'\n\t}\"\n></div>\n", styles: [".spinner{animation:load 1s linear infinite;border-radius:50%;border-style:solid}@keyframes load{0%{transform:rotate(0)}to{transform:rotate(360deg)}}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], size: [{
                type: Input
            }], borderWidth: [{
                type: Input
            }] } });

class DzProgressSpinnerModule {
}
DzProgressSpinnerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzProgressSpinnerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DzProgressSpinnerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzProgressSpinnerModule, declarations: [DzProgressSpinnerComponent], imports: [CommonModule], exports: [DzProgressSpinnerComponent] });
DzProgressSpinnerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzProgressSpinnerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: DzProgressSpinnerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DzProgressSpinnerComponent],
                    imports: [CommonModule],
                    exports: [DzProgressSpinnerComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DzProgressSpinnerComponent, DzProgressSpinnerModule };
